import React, {Component} from 'react';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import FormValidator from "../FormValidator";
import * as PostCodes from '../../Assets/PostCodes';
import '../../styles/FormStyle.css';

const initialState = {
  street: '',
  housenumber: '',
  housenumberextension: '',
  postcode: '',
  city: '',
  check: false
}

class CancelConsumptionPoint extends Component{
  constructor(props){
    super(props);
    this.check= false;
    this.validator = new FormValidator([
        //https://www.npmjs.com/package/validator
      {
        field: 'street',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Adresse an.'
      },
      {
        field: 'housenumber',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Pflichtfeld'
      },
      {
        field: 'housenumber',
        method: 'isInt',
        validWhen: true,
        message: 'Muss eine Nummer sein.'
      },
      {
        field: 'postcode',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Postleitzahl an.'
      },
      {
        field: 'postcode',
        method: 'isInt',
        validWhen: true,
        message: 'PLZ muss eine Nummer sein.'
      },
      {
        field: 'postcode',
        method: 'isLength',
        args: [{min: 5, max: 5}],
        validWhen: true,
        message: 'PLZ besteht aus 5 Ziffern.'
      },
      {
        field: 'postcode',
        method: this.checkZipCode,
        validWhen: true,
        message: 'Für diese PLZ aktuell leider nicht möglich.'
      },
      {
        field: 'city',
        method: 'isEmpty',
        args: [{ignore_whitespace:true}],
        validWhen: false,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Ort an.'
      },
      {
        field: 'additionalMeternumber',
        method: this.checkMeternumber,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Zählernummer an.'
      },
      {
        field: 'additionalMeterreading',
        method: this.checkMeterreading,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie den Zählerstand an.'
      },
      {
        field: 'additionalContractNumber',
        method: this.checkAdditionalContract,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Dies ist ein Pflichtfeld, bitte geben Sie die Vertragnummer zum Gaszähler an.'
      },
      {
        field: 'additionalContractNumber',
        method: this.checkAccountNumberBegin,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Vertragnummer beginnt mit der Ziffer "2"'
      },
      {
        field: 'additionalContractNumber',
        method: this.checkAccountNumberLength,
        args: [{ignore_whitespace:true}],
        validWhen: true,
        message: 'Die Vertragskontonummer besteht aus 12 Ziffern.'
      },
    
    ]);
    
    this.state = {
      ...initialState,
      ...props.state,
      validation: this.validator.valid()
    }

    const isVal = this.validator.validate(this.state);
    props.isValidForm(isVal.isValid, 'adressValidation');

    this.handleChange = this.handleChange.bind(this);
  }

  checkZipCode = () => {
    if (this.props.isRegistration) {
        if (this.props.state.metertype === 'electricity' ) {
          return PostCodes.postcodesEnergy.includes(this.state.postcode);
        }
        if (this.props.state.metertype === 'gas') {
          return PostCodes.postcodesGas.includes(this.state.postcode);
        }
    } else {
      return true;
    }
  }
  checkMeternumber = () => {
    if (this.props.state.metertype === "electricity" && this.check && this.props.state.additionalMeternumber === '') {
        return false;
    } else {
      return true;
    }
  }
  checkMeterreading = () => {
    if (this.props.state.metertype === "electricity" && this.check && this.props.state.additionalMeterreading === '') {
      return false;
    } else {
      return true;
    }
  }
  checkAdditionalContract = () => {
    if (this.props.state.metertype === "electricity" && this.check && this.props.state.additionalContractNumber === '') {
      return false;
    } 
      else {
      return true;
    }
  }
  checkAccountNumberBegin = () => {
    if (this.props.state.metertype === "electricity" && this.check && this.props.state.additionalContractNumber[0] !== '2') {
      return false;
    } 
    else {
      return true;
    }
  }
  checkAccountNumberLength = () => {
    if (this.props.state.metertype === "electricity" && this.check && this.props.state.additionalContractNumber.length !== 12) {
      return false;
    }
    else {
      return true;
    }
  }



  componentDidUpdate() {
    // check if the upper instance has resettet its state
    if(this.state.street !== this.props.state.street){
      // reset too
      this.setState({
        ...this.props.state
      });
    }
  }
  handleChecked = () => {
    this.props.handleChangeChecked();
    this.setState({
       check: this.props.checked,
    });
    
  }

  handleChange(event) {
    this.props.changeHandler(event);

    this.setState({
      [event.target.name]: event.target.value
    }, () => { // callback to send validation to upper instance after state was updatet
      const isVal = this.validator.validate(this.state);
      this.props.isValidForm(isVal.isValid, 'adressValidation');
    });
  }

  render(){
    // validator will start alerting after first submission
    let validation = this.props.submitted ? this.validator.validate(this.state) : this.state.validation;
    let addition;
    let checkboxes;
    this.check= this.props.checked;
    if(this.props.type === "electricity") {
    addition =  
      <Row>
        <h4 id="checkboxtext"> 
        <input id="input" type="checkbox" checked={this.check} name="checked" onChange={this.handleChecked} />
        GASAG | ERDGAS Leerstand gleich mit abmelden?</h4>
      </Row>;
    if(this.check) {
      checkboxes =
    <div>
      <Row>
        <Col md={8}>
          <FormGroup>
            <div className={validation.additionalContractNumber.isInvalid ? 'has-error' : ''}>
              <Label for="additionalContractNumber">Vertragsnummer zum Gaszähler*</Label>
              <Input type="number" placeholder="EINGABEFORMAT: 200123456789" value={this.state.additionalContractNumber} name="additionalContractNumber" id="additionalContractNumber" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.additionalContractNumber.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
        <FormGroup>
          <div className={validation.additionalMeternumber.isInvalid ? 'has-error' : ''}>
            <Label for="additionalMeternumber">Gaszählernummer*</Label>
            <Input type="text" value={this.state.additionalMeternumber} name="additionalMeternumber" id="additionalMeternumber" onChange={this.handleChange.bind(this)}/>
            <span className="help-block">{validation.additionalMeternumber.message}</span>
          </div>
        </FormGroup>
        </Col>
        <Col md={6}>
        <FormGroup>
          <div className={validation.additionalMeterreading.isInvalid ? 'has-error' : ''}>
            <Label for="additionalMeterreading">Zählerstand*</Label>
            <Input type="number" value={this.state.additionalMeterreading} name="additionalMeterreading" id="additionalMeterreading" onChange={this.handleChange.bind(this)}/>
            <span className="help-block">{validation.additionalMeterreading.message}</span>
          </div>
        </FormGroup>
        </Col>
      </Row>
    </div>
      }  
    }

    return (
      <div>
      <Row>
        <Col md={4}>
          <FormGroup>
            <div className={validation.street.isInvalid ? 'has-error' : ''}>
              <Label for="street">Straße*</Label>
              <Input type="text" value={this.state.street} name="street" id="street" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.street.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup>
            <div className={validation.housenumber.isInvalid ? 'has-error' : ''}>
              <Label for="housenumber">Hausnr.*</Label>
              <Input type="text" value={this.state.housenumber} name="housenumber" id="housenumber" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.housenumber.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={1}>
          <FormGroup>
            <div>
              <Label for="housenumberextension">Erw.</Label>
              <Input type="text" value={this.state.housenumberextension} name="housenumberextension" id="housenumberextension" onChange={this.handleChange.bind(this)}/>
            </div>
          </FormGroup>
        </Col>
        <Col md={2}>
          <FormGroup>
            <div className={validation.postcode.isInvalid ? 'has-error' : ''}>
              <Label for="postcode">Postleitzahl*</Label>
              <Input type="number" value={this.state.postcode} name="postcode" id="postcode" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.postcode.message}</span>
            </div>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <div className={validation.city.isInvalid ? 'has-error' : ''}>
              <Label for="city">Ort*</Label>
              <Input type="text" value={this.state.city} name="city" id="city" onChange={this.handleChange.bind(this)}/>
              <span className="help-block">{validation.city.message}</span>
            </div>
          </FormGroup>
        </Col>
      </Row>
      {addition}
      {checkboxes}
      <h6>* Pflichtfelder - Diese Angaben benötigen wir, um Ihren Auftrag zu bearbeiten. Vielen Dank.</h6>
      </div>
    );
  }
}

export default CancelConsumptionPoint;


// WEBPACK FOOTER //
// ./src/components/FormGroups/CancelConsumptionPoint.js